export const PRODUCT_DOWNLOAD_TAB = {
    TECHNICAL: "technical",
    MARKETING: "marketing",
} as const;

export type ProductDownloadTabId =
    (typeof PRODUCT_DOWNLOAD_TAB)[keyof typeof PRODUCT_DOWNLOAD_TAB];
